import React from "react";
import Chip from "@mui/material/Chip";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface CustomChipProps {
  children: React.ReactNode;
  icon?: "check" | "close";
}

const CustomChip: React.FC<CustomChipProps> = ({ children, icon }) => {
  const getIcon = () => {
    if (icon === "check")
      return <CheckIcon sx={{ fontSize: 16, color: "#e3f2fd" }} />;

    if (icon === "close")
      return <CloseIcon sx={{ fontSize: 16, color: "#e3f2fd" }} />;

    return undefined; // MUST NOT return null
  };

  return (
    <Chip
      label={children}
      icon={getIcon()}
      clickable={false}
      sx={{
        backgroundColor: "#3969E7",
        color: "#e3f2fd",
        fontSize: "12px",
        fontFamily: "Poppins, sans-serif",  // ← HERE
        height: "28px",
        borderRadius: "6px",

        "& .MuiChip-label": {
          fontFamily: "Poppins, sans-serif",
          fontWeight: 400,
          padding: "4px 6px",
        },

        "& .MuiChip-icon": {
          marginLeft: "4px",
        },
      }}
    />
  );
};

export default CustomChip;
